
import React from "react";
import api from '../../api/Api'
import Loader from '../../components/Loader'
import ReactTable from "react-table";
import {NavLink} from "react-router-dom";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/Person";
import matchSorter from "match-sorter";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId
} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
class Patients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            open: true,
            element: "",
            api_status: "",
            read: false,
            alert: null,
            clinicMasterList: null,
            clickedId: "",
            selectedId: "",
            clinicsData: null,
            clinicmaster_id: null,
            patientList: null,
            pageNo: 0,
            pages: 0,
            limit: 10,
            loading: false,
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.CallDeleteApi = this.CallDeleteApi.bind(this)
    }

    componentDidMount() {
        this.CallReadApi();
        this.setState({clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()})
    }

    render() {
        const {classes} = this.props;
        const {data, clinicMasterList, clinicsData, patientList} = this.state;
        if((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) { this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id) }
        if (this.state.clinicMasterList && data)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        { mappingUI(Permissions.AddPatient) ? <GridItem xs={12} sm={12} md={2}>
                            <NavLink to={dashboardRouter("/patient/addPatient")}>
                                <Button block color="warning">
                                    <Icon>add</Icon>
                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                </Button>
                            </NavLink>
                        </GridItem> : null}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4>Patients</h4>
                                                <p>
                                                    List of all Patients
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                    <span>
                                               <GridContainer>

                                    < GridItem xs={12} sm={6} md={6}>
                                    </GridItem>
                                    < GridItem xs={12} sm={6} md={6}>
                                        {isClinicMasterOrClinic() === "" ? <FormControl
                                            fullWidth>
                                            <InputLabel
                                                htmlFor="clinicmaster_id">
                                                Clinic Master
                                            </InputLabel>
                                            <Select
                                                value={this.state.clinicmaster_id}
                                                onChange={this.onChangeSelect}
                                                inputProps={{
                                                    name: "clinicmaster_id",
                                                    id: "clinicmaster_id"
                                                }}>
                                                <MenuItem
                                                    disabled>
                                                    Select Clinic
                                                </MenuItem>
                                                {clinicMasterList.map((x) => {
                                                    return <MenuItem key={Math.random()}
                                                                     style={{height: "1.8em"}}
                                                                     value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl> : null}
                                        <br/>
                                        {isClinicMasterOrClinic() === "" && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                            <FormControl
                                                fullWidth>
                                                <InputLabel
                                                    htmlFor="clinic_id">
                                                    Clinic
                                                </InputLabel>
                                                <Select
                                                    value={this.state.clinic_id}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "clinic_id",
                                                        id: "clinic_id"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                    >
                                                        Select Clinic
                                                    </MenuItem>
                                                    {clinicsData.map((x) => {
                                                        return <MenuItem key={Math.random()}
                                                                         style={{height: "1.8em"}}
                                                                         value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            : null}
                                    </GridItem></GridContainer>
                                    </span>
                                </CardHeader>
                                <CardBody>

                                    {patientList ?
                                        <ReactTable

                                            data={patientList}
                                            // manual
                                            // pages={this.state.pages}
                                            // showPageJump={false}
                                            //  pageSizeOptions={[10]}
                                            // loading={this.state.loading}
                                            //  pageSize={10}
                                            // onFetchData={(state, instance) => {
                                            //     if (state.page > 0 || state.pageSize !== 10 || state.sorted.length > 0) {
                                            //         this.setState({loading: true});
                                            //         api.getPatientsByPagination({
                                            //             page: state.page,
                                            //             limit: state.pageSize,
                                            //             query: state.filtered.length > 0 ? state.filtered[0].value : "",
                                            //             sort: state.sorted.length > 0 ? state.sorted[0].id : "",
                                            //             order: state.sorted.length > 0 ? state.sorted[0].desc ? -1 : 1 : ""
                                            //         }).then(json => {
                                            //             this.setState({
                                            //                 data: json.data.data.data,
                                            //                 pageNo: json.data.data.page,
                                            //                 pages: Math.floor(json.data.data.total / state.pageSize) + 1,
                                            //                 loading: false
                                            //             }, () => {
                                            //                 this.setState({
                                            //                     patientList: this.state.data.map(item => {
                                            //                         return {
                                            //                             "_id": item._id,
                                            //                             "name": item.user_id.name,
                                            //                             "age": item.user_id.age,
                                            //                             "contact": item.user_id.contact,
                                            //                             "email": item.user_id.email,
                                            //                             "gender": item.gender,
                                            //                             "user_id": item.user_id._id
                                            //                         }
                                            //                     })
                                            //                 })
                                            //             })
                                            //         });
                                            //     }
                                            // }}
                                            // onFilteredChange={(filtered, column) => {
                                            //     if (filtered[0] && filtered[0].value && filtered[0].value.length > 2) {
                                            //         this.setState({loading: true});
                                            //         api.getPatientsByPagination({
                                            //             limit: this.state.limit,
                                            //             query: filtered[0].value
                                            //         }).then(json => {
                                            //             this.setState({
                                            //                 data: json.data.data.data,
                                            //                 pageNo: json.data.data.page,
                                            //                 pages: Math.floor(json.data.data.total / 10) + 1,
                                            //                 loading: false
                                            //             }, () => {
                                            //                 this.setState({
                                            //                     patientList: this.state.data.map(item => {
                                            //                         return {
                                            //                             "_id": item._id,
                                            //                             "name": item.user_id.name,
                                            //                             "age": item.user_id.age,
                                            //                             "contact": item.user_id.contact,
                                            //                             "email": item.user_id.email,
                                            //                             "gender": item.gender,
                                            //                             "user_id": item.user_id._id
                                            //                         }
                                            //                     })
                                            //                 })
                                            //             })
                                            //         });
                                            //     }
                                            //     else {
                                            //         api.getPatientsByPagination({
                                            //             limit: this.state.limit,
                                            //         }).then(json => {
                                            //             this.setState({
                                            //                 data: json.data.data.data,
                                            //                 pageNo: json.data.data.page,
                                            //                 pages: Math.floor(json.data.data.total / 10) + 1,
                                            //                 loading: false
                                            //             }, () => {
                                            //                 this.setState({
                                            //                     patientList: this.state.data.map(item => {
                                            //                         return {
                                            //                             "_id": item._id,
                                            //                             "name": item.user_id.name,
                                            //                             "age": item.user_id.age,
                                            //                             "contact": item.user_id.contact,
                                            //                             "email": item.user_id.email,
                                            //                             "gender": item.gender,
                                            //                             "user_id": item.user_id._id
                                            //                         }
                                            //                     })
                                            //                 })
                                            //             })
                                            //         });
                                            //     }
                                            // }}
                                            filterable
                                            // defaultFilterMethod={(filter, row) =>
                                            // String(row[filter._id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Patient Name",
                                                            accessor: "name",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p style={{cursor: 'pointer'}}><NavLink
                                                                            to={dashboardRouter(`/patient/${patientList[index]._id}`)}>{patientList[index].name}</NavLink>
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["name"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: "Age",
                                                            id: "age",
                                                            accessor: "age",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{patientList[index].age}</p>
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false
                                                        },
                                                        {
                                                            Header: "Email",
                                                            accessor: "email",
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["gender"]}),
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{patientList[index].email}</p>
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false
                                                        },
                                                        {
                                                            Header: "Contact",
                                                            accessor: "contact",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{patientList[index].contact}</p>
                                                                    </div>
                                                                ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["contact"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        { mappingUI(Permissions.ViewPatient) ? <NavLink
                                                                            to={dashboardRouter(`/patient/${patientList[index]._id}`)}>
                                                                            <Tooltip
                                                                                id="tooltip-top"
                                                                                title="View"
                                                                                placement="bottom"
                                                                                classes={{tooltip: classes.tooltip}}>
                                                                                <Button type="button" color="info"
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            marginLeft: '10%'
                                                                                        }}>
                                                                                    <Icon
                                                                                        style={{fontSize: 20}}>info</Icon>
                                                                                </Button>
                                                                            </Tooltip> </NavLink> : null}
                                                                        { mappingUI(Permissions.UpdatePatient) ?
                                                                            <NavLink
                                                                                to={dashboardRouter(`/patient/updatePatient/${patientList[index]._id}`)}>
                                                                                <Tooltip
                                                                                    id="tooltip-top"
                                                                                    title="Edit"
                                                                                    placement="bottom"
                                                                                    classes={{tooltip: classes.tooltip}}>
                                                                                    <Button type="button"
                                                                                            color="success"
                                                                                            style={{
                                                                                                padding: 8,
                                                                                                marginLeft: '5%'
                                                                                            }}
                                                                                    >
                                                                                        <Icon
                                                                                            style={{fontSize: 20}}>edit</Icon>
                                                                                    </Button>
                                                                                </Tooltip>
                                                                            </NavLink> : null}
                                                                        { mappingUI(Permissions.DeletePatient) ?
                                                                            <Tooltip
                                                                                id="tooltip-top"
                                                                                title="Remove"
                                                                                placement="bottom"
                                                                                classes={{tooltip: classes.tooltip}}>
                                                                                <Button type="button" color="danger"
                                                                                        onClick={() => {
                                                                                            this.CreateAlert(patientList[index].user_id);
                                                                                        }}
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            marginLeft: '5%'
                                                                                        }}>
                                                                                    <Icon
                                                                                        style={{fontSize: 20}}>close</Icon>
                                                                                </Button></Tooltip> : null}
                                                                    </div>
                                                                )
                                                        }
                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        /> : null}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    CallReadApi = () => {
        api.fetchPatientsByClinicMaster().then(json => {
            // api.getPatientsByPagination({"page": this.state.pageNo, limit: this.state.limit}).then(json => {
            this.setState({
                data: json.data.data,
                // pages: Math.floor(json.data.data.total / 10) + 1,
            }, () => {
                this.setState({
                    patientList: this.state.data.map(item => {
                        // patientList: this.state.data.data.map(item => {
                        return {
                            "_id": item._id,
                            "name": item.user_id.name,
                            "age": item.user_id.age,
                            "contact": item.user_id.contact,
                            "email": item.user_id.email,
                            "gender": item.gender,
                            "user_id": item.user_id._id
                        }
                    })
                })
            })
        });
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",
            // "page": 0,
            // "limit": this.state.limit
        };

        this.setState({data: null, patientList: null});
        // api.getPatientsByPagination(postBody).then(json => {
        api.fetchPatientsByClinicMaster(postBody).then(json => {
            this.setState({data: json.data.data}, () => {
                this.setState({
                    patientList: this.state.data.map(item => {
                        // patientList: this.state.data.data.map(item => {
                        return {
                            "_id": item._id,
                            "name": item.user_id.name,
                            "age": item.user_id.age,
                            "contact": item.user_id.contact,
                            "email": item.user_id.email,
                            "gender": item.gender
                        }
                    })
                    // , pages: Math.floor(json.data.data.total / 10) + 1,
                })
            })
        });
    }

    DeleteAlert = (param1, param2) => (e) => {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Are you sure you want to Delete?</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideDeleteAlert}>
                            Disagree
                        </Button>
                        <Button onClick={this.CallDeleteApi} color="danger" autoFocus>
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            ),
            selectedId: param2
        });
    }

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    }

    CallDeleteApi() {
        api.deletePatientById(this.state.selectedId).then(json => {
            this.setState({alert: null, redirectAll: true});
            this.CallReadApi();
        })
        // this.searchOnFilter();
        // window.location.reload()
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    deleteRecord(id) {
        var postBody = {"user_id": id};
        api.deletePatient(postBody)
            .then(json => {
            });

    }

    successDelete() {
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block", marginTop: "-100px"}}
                    title="Deleted!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                >
                </SweetAlert>
            )
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
        window.location.reload()

    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure?"
                    onConfirm={() => {
                        this.successDelete();
                            this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel>
                    You will not be able to recover this patient!
                </SweetAlert>
            )
        });
    }
}

export default withStyles(sweetAlertStyle)(Patients);



// WEBPACK FOOTER //
// ./src/views/Patients/Patients.jsx